// alternative-components/cards/CashAvailableCard.tsx
import { useCountry } from "@/app/services/context/CountryContext";
import { gxCurrencyFormat } from "@/app/utils/helpers/gxCurrencyFormat";
import { useAccountBalanceQuery } from "@/app/hooks/useAccountBalanceQuery";
interface DashboardCardProps {
  title: string;
}

const CashAvailableCard = ({ title }: DashboardCardProps) => {
  const { selectedCountry } = useCountry();
  const currencyCode = selectedCountry?.currency?.code ?? "";

  const { data: apiData, isLoading } = useAccountBalanceQuery(currencyCode);

  const currencyLabel =
    apiData?.totalbalance?.currency ?? selectedCountry?.currency?.code ?? "";
  const totalBalance = apiData?.totalbalance?.totalBalance ?? 0;
  const assetsCount = apiData?.totalassetsbalance?.casa ?? 0;

  const formatted = gxCurrencyFormat(totalBalance, currencyLabel);
  const currencySymbol = formatted.symbol;

  return (
    <div className="gx-alter-card">
      <h3 className="gx-alter-approval-header-text gx-p16-sb">{title}</h3>

      <div className="gx-alter-approval-currency">
        <p className="alter-approval-policy-currency gx-p18-sb">
          {isLoading ? "" : currencySymbol}
        </p>

        <span className="gx-alter-approval-text-value gx-36-sb">
          {isLoading ? "-" : formatted.integer}
        </span>

        <span className="gx-alter-approval-text-value gx-text-gray gx-36-sb">
          {isLoading ? "" : formatted.decimal}
        </span>
      </div>

      <p className="alter-approval-policy-text gx-p14-b">
        {assetsCount} Accounts
      </p>
    </div>
  );
};

export default CashAvailableCard;
